/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
import { useState, useEffect, useCallback } from "react";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import moment from "moment";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import moment from 'moment'
import { AiOutlineFileExclamation } from "react-icons/ai";

/* Descomentar para Update da Certidao conjunta anonimizada */
import fileHidden from "../../assets/filehidden1.png";

import apiRelatorio from "../../services/apiRelatorio";
import { useAuth } from "../../hooks/auth";
import { BO } from "../../interface/Bo";

import { MenuBoepm } from "../../components/menu-boepm/MenuBoepm";
import "./tabela.css";

interface Unidade {
  ID_UNID_OPERACIONAL: number;
  CD_OPERACIONAL: string;
}

export const BoPorOmeData: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [bos, setBos] = useState<BO[]>([]);
  const [total, setTotal] = useState(0);
  const [totalBo, setTotalBo] = useState(null);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [, setLoadingBO] = useState(false);
  const [dataInicial, setDataInicial] = useState<string | undefined>(undefined);
  const [datafinal, setDataFinal] = useState<string | undefined>(undefined);
  const [unidades, setUnidades] = useState<Unidade[]>([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const { logout } = useAuth();

  const storedToken = sessionStorage.getItem("@webSDS:token");

  const handleSelectChange = (event: MUI.SelectChangeEvent) => {
    event.preventDefault();
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    apiRelatorio
      .get("unidOperacional", {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setUnidades(response.data);
      });
  }, [setUnidades, storedToken]);

  useEffect(() => {
    setLoadingBO(true);
    const totalBos = async () => {
      try {
        const response = await apiRelatorio.get(`relatorios/0/20`, {
          headers: {
            id_ome: selectedOption,
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (response.status === 200) {
          setTotalBo(response.data.total);
          setBos({ ...bos });
        }
        if (response.status === 401) {
          toast.error(
            "A Sua sessão expirou, efetue login novamente para continuar usando o Polícia Ágil",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          logout();
        }

        setLoadingBO(false);
      } catch (error) {
        setLoading(false);
        toast.error("Erro de conexão! Verifique sua internet", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
    };
    totalBos();
  }, [logout, selectedOption, storedToken]);

  const boPorOMEData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiRelatorio.get(`relatorios/0/20`, {
        headers: {
          id_ome: selectedOption,
          Authorization: `Bearer ${storedToken}`,
        },
        params: {
          data_inicial: dataInicial
            ? moment(dataInicial).format("DD/MM/YYYY")
            : dataInicial,
          data_final: datafinal
            ? moment(datafinal).format("DD/MM/YYYY")
            : datafinal,
        },
      });

      if (response.status === 200) {
        setBos(response.data.bos);
        setTotal(response.data.total);
      }

      if (response.status === 404) {
        toast.error(`${response.data.message}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
        setBos([]);
      }
      if (response.status === 401) {
        toast.error(
          "A Sua sessão expirou, efetue login novamente para continuar usando o Polícia Ágil",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          }
        );
        logout();
      }
      if (response.status === 500 || response.status === 503) {
        toast.error(`${response.data.message}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
      if (response.status === 504) {
        toast.error(
          "O Servidor demorou muito pra responder, tente novamente em instantes.",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          }
        );
      }
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      toast.error("Erro de conexão! Verifique sua internet", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 4000,
      });
    }
  }, [dataInicial, datafinal, logout, selectedOption, storedToken]);

  const handleChangePage = useCallback(
    async (newPage: number) => {
      setPage(newPage);
      setLoadingPage(true);

      const response = await apiRelatorio.get(`relatorios/${newPage}/20`, {
        headers: {
          id_ome: selectedOption,
          Authorization: `Bearer ${storedToken}`,
        },
        params: {
          data_inicial: dataInicial
            ? moment(dataInicial).format("DD/MM/YYYY")
            : dataInicial,
          data_final: datafinal
            ? moment(datafinal).format("DD/MM/YYYY")
            : datafinal,
        },
      });
      setBos(response.data.bos);
      setTotal(response.data.total);
      setLoadingPage(false);
    },
    [dataInicial, datafinal, selectedOption, storedToken]
  );

  const limparData = () => {
    setBos([]);
    setDataInicial("");
    setDataFinal("");
    setPage(0);
  };

  return (
    <MUI.Stack flexDirection="row" width="100%" height={["95vh", "80vh"]}>
      <MenuBoepm />

      <MUI.Stack gap={2} p={2} flex={1}>
        <MUI.Stack
          gap={[0, 1]}
          flexDirection={["column", "row"]}
          alignItems={["inherit", "center"]}
        >
          <MUI.FormControl sx={{ width: 300 }} size="small">
            <MUI.InputLabel>Unidades</MUI.InputLabel>
            <MUI.Select
              label="Unidades"
              value={selectedOption}
              onChange={handleSelectChange}
            >
              <MUI.MenuItem value="">TODOS</MUI.MenuItem>
              {unidades.map((unidade) => (
                <MUI.MenuItem
                  key={unidade.ID_UNID_OPERACIONAL}
                  value={unidade.ID_UNID_OPERACIONAL}
                >
                  {unidade.CD_OPERACIONAL}
                </MUI.MenuItem>
              ))}
            </MUI.Select>
          </MUI.FormControl>
          {totalBo && (
            <MUI.Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "blue",
              }}
            >
              {totalBo} boletins de ocorrência
            </MUI.Typography>
          )}
        </MUI.Stack>

        <MUI.Grid
          alignItems="center"
          width={["100%", "100%", "100%", "80%", "60%"]}
          container
          spacing={1}
        >
          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.TextField
              type="date"
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
              label="Data inicial Ex: 20/07/2021"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              size="small"
              disabled={loading}
            />
          </MUI.Grid>

          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.TextField
              type="date"
              value={datafinal}
              onChange={(e) => setDataFinal(e.target.value)}
              label="Data final Ex: 22/07/2021"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              size="small"
              disabled={loading}
            />
          </MUI.Grid>

          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={boPorOMEData}
              disabled={loading}
              startIcon={<Icon.Search />}
            >
              <MUI.Typography
                variant="button"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
              >
                Pesquisar
              </MUI.Typography>
            </MUI.Button>
          </MUI.Grid>

          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={limparData}
              disabled={loading}
              startIcon={<Icon.Clear />}
            >
              <MUI.Typography
                variant="button"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
              >
                Limpar resultado
              </MUI.Typography>
            </MUI.Button>
          </MUI.Grid>
        </MUI.Grid>

        {!loading ? (
          bos.length > 0 ? (
            <>
              {loadingPage ? (
                <MUI.LinearProgress />
              ) : (
                <>
                  <MUI.Stack
                    width="97.5%"
                    my={1}
                    overflow="auto"
                    sx={{
                      boxShadow: "0 0 0.3rem #000000",
                    }}
                  >
                    <Table className="table">
                      <Thead>
                        <Tr>
                          <Th>Nº BO</Th>
                          <Th>Data</Th>
                          <Th>Natureza</Th>
                          <Th>Viatura</Th>
                          <Th>Condutor</Th>
                          <Th>Resultado da Ocorrência</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {bos.map((bo) => (
                          <Tr key={bo.ID_BO}>
                            <Td>
                              {/* Descomentar para Update da Certidao conjunta anonimizada */}
                              <div
                                style={{
                                  display: "flex",
                                  margin: -5,
                                  flexDirection: "row",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <a
                                  className="linkBo"
                                  href={`${
                                    process.env.REACT_APP_URL_CERTIDAO
                                  }/certidao/${
                                    bo.ID_STATUS === 4 && bo.BO_DP
                                      ? bo.BO_DP
                                      : "1"
                                  }/${bo.CD_OCORRENCIA}/${bo.CRC}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {bo.CD_OCORRENCIA}
                                </a>
                                <a
                                  className="linkBoAnonimo"
                                  href={`${
                                    process.env.REACT_APP_URL_CERTIDAO
                                  }/certidao/${
                                    bo.ID_STATUS === 4 && bo.BO_DP
                                      ? bo.BO_DP
                                      : "1"
                                  }/${bo.CD_OCORRENCIA}/${bo.CRCH}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={fileHidden}
                                    alt="imagem"
                                    width={20}
                                    height={20}
                                  />
                                </a>
                              </div>
                            </Td>

                            <Td>{bo.DATA_HORA}</Td>

                            <Td>{bo.NATUREZAS}</Td>

                            <Td>{bo.DS_VIATURA}</Td>

                            <Td>{bo.CONDUTOR}</Td>

                            <Td>{bo.NM_TIPO_DESFECHO}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </MUI.Stack>
                  <MUI.Stack
                    width="97.5%"
                    alignItems="center"
                    justifyContent="space-between"
                    flexDirection="row"
                    p={0.5}
                  >
                    <MUI.Typography variant="body2">
                      Quantidade de BO's produzido neste período: {total}
                    </MUI.Typography>
                    <MUI.Stack flexDirection="row" alignItems="center">
                      {page > 0 && (
                        <MUI.IconButton
                          type="button"
                          onClick={() => handleChangePage(page - 1)}
                        >
                          <Icon.KeyboardArrowLeft />
                        </MUI.IconButton>
                      )}
                      <span>{page + 1}</span>
                      {Math.floor(total / 20) > page && total !== 20 && (
                        <MUI.IconButton
                          type="button"
                          onClick={() => handleChangePage(page + 1)}
                        >
                          <Icon.ChevronRight />
                        </MUI.IconButton>
                      )}
                    </MUI.Stack>
                  </MUI.Stack>
                </>
              )}
            </>
          ) : (
            false
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
